import styled from 'styled-components';
import { Text } from '~/components/ui/Text';

const StyledContainer = styled.div<{ $minWidth: number }>`
	position: absolute;
	top: 108px;
	right: 30px;
	display: flex;
	align-items: center;
	justify-content: space-between;
	gap: 10px;
	min-width: ${(props) => props.$minWidth}px;
	height: 40px;
	padding: 5px 5px 5px 10px;
	background-color: rgba(17, 19, 20, 0.95);
	border: 1px solid rgba(255, 255, 255, 0.1);
	border-radius: 10px;
	user-select: none;
	pointer-events: none;

	transition:
		opacity 0.5s ease,
		transform 0.5s ease;
	transform: translateX(100%);
	opacity: 0;

	&.playtime-reward-enter {
		opacity: 0;
		transform: translateX(100%);
	}

	&.playtime-reward-enter-active,
	&.playtime-reward-enter-done,
	&.playtime-reward-exit {
		opacity: 1;
		transform: translateX(0);
	}

	&.playtime-reward-exit-active {
		opacity: 0;
		transform: translateX(100%);
	}
`;

const StyledLabel = styled(Text)`
	font-size: 16px;
	font-weight: 400;
	white-space: nowrap;
	color: rgba(255, 255, 255, 0.5);

	span {
		font-weight: 500;
		color: #ffffff;
	}
`;

const StyledReward = styled.div<{ $isReceived: boolean }>`
	display: flex;
	align-items: center;
	justify-content: center;
	gap: 10px;
	height: 30px;
	padding: 0 10px;
	border-radius: 5px;
	background-color: ${(props) => (props.$isReceived ? '#0085FF' : '#1F8034')};

	img {
		flex-shrink: 0;
		width: 16px;
		height: 16px;
	}
`;

const StyledRewardAmount = styled(Text)`
	font-size: 16px;
	font-weight: 700;
	color: #ffffff;
`;

const StyledRewardLabel = styled(Text)`
	font-size: 16px;
	font-weight: 500;
	color: #ffffff;
`;

export {
	StyledContainer,
	StyledLabel,
	StyledReward,
	StyledRewardAmount,
	StyledRewardLabel,
};
